'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.LOA_CONTENT_FAILED = exports.LOA_CONTENT_FETCHED = exports.LOA_CONTENT_FETCHING = exports.LOA_STATUS_FAILED = exports.LOA_STATUS_FETCHED = exports.LOA_STATUS_FETCHING = exports.SHARED_INFO_FETCHED = exports.SHARED_INFO_FETCHING = exports.TERMS_UPDATED = exports.TERMS_UPDATING = exports.TERMS_STATUS_FETCHED = exports.TERMS_STATUS_FETCHING = exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = exports.TERMS_FETCHED = exports.TERMS_FETCHING = exports.TOGGLE_TAC_MODAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchLOAStatus = fetchLOAStatus;
exports.fetchLOAContent = fetchLOAContent;
exports.fetchTermsStatus = fetchTermsStatus;
exports.fetchTermsContent = fetchTermsContent;
exports.fetchSharedInfoContent = fetchSharedInfoContent;
exports.updateTerms = updateTerms;
exports.toggleTaCModal = toggleTaCModal;
exports.launchTaCModal = launchTaCModal;
exports.updateCurrentlyAccepted = updateCurrentlyAccepted;
exports.default = terms;

var _merge4 = require('lodash/merge');

var _merge5 = _interopRequireDefault(_merge4);

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _listingModule = require('../listing/listingModule');

var listingActions = _interopRequireWildcard(_listingModule);

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var APIEndpoint = (0, _utils.getAPIEndpoint)();

var TOGGLE_TAC_MODAL = exports.TOGGLE_TAC_MODAL = '@@termsModule/TOGGLE_TAC_MODAL';
var TERMS_FETCHING = exports.TERMS_FETCHING = '@@termsModule/TERMS_FETCHING';
var TERMS_FETCHED = exports.TERMS_FETCHED = '@@termsModule/TERMS_FETCHED';
var UPDATE_PREVIOUSLY_ACCEPTED_STATUS = exports.UPDATE_PREVIOUSLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_PREVIOUSLY_ACCEPTED_STATUS';
var UPDATE_CURRENTLY_ACCEPTED_STATUS = exports.UPDATE_CURRENTLY_ACCEPTED_STATUS = '@@termsModule/UPDATE_CURRENTLY_ACCEPTED_STATUS';
var TERMS_STATUS_FETCHING = exports.TERMS_STATUS_FETCHING = '@@termsModule/TERMS_STATUS_FETCHING';
var TERMS_STATUS_FETCHED = exports.TERMS_STATUS_FETCHED = '@@termsModule/TERMS_STATUS_FETCHED';
var TERMS_UPDATING = exports.TERMS_UPDATING = '@@termsModule/TERMS_UPDATING';
var TERMS_UPDATED = exports.TERMS_UPDATED = '@@termsModule/TERMS_UPDATED';
var SHARED_INFO_FETCHING = exports.SHARED_INFO_FETCHING = '@@termsModule/SHARED_INFO_FETCHING';
var SHARED_INFO_FETCHED = exports.SHARED_INFO_FETCHED = '@@termsModule/SHARED_INFO_FETCHED';

var LOA_STATUS_FETCHING = exports.LOA_STATUS_FETCHING = '@@termsModule/LOA_STATUS_FETCHING';
var LOA_STATUS_FETCHED = exports.LOA_STATUS_FETCHED = '@@termsModule/LOA_STATUS_FETCHED';
var LOA_STATUS_FAILED = exports.LOA_STATUS_FAILED = '@@termsModule/LOA_STATUS_FAILED';

var LOA_CONTENT_FETCHING = exports.LOA_CONTENT_FETCHING = '@@termsModule/LOA_CONTENT_FETCHING';
var LOA_CONTENT_FETCHED = exports.LOA_CONTENT_FETCHED = '@@termsModule/LOA_CONTENT_FETCHED';
var LOA_CONTENT_FAILED = exports.LOA_CONTENT_FAILED = '@@termsModule/LOA_CONTENT_FAILED';

function fetchLOAStatus(userId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var stateId, _getState, _getState$JWT, _getState$JWT$token, token, options, response, status;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // there are two places to get userId, we should consolidate.
              // one comes from us encoding what we have from session, the other from an api call
              stateId = (0, _get3.default)(getState(), 'userProfile.profile.UserID', false);

              if (!(!userId && !stateId)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return', Promise.reject(new Error('could not find a userId in fetchLOAStatus call or state')));

            case 3:

              dispatch({ type: LOA_STATUS_FETCHING });
              _getState = getState(), _getState$JWT = _getState.JWT;
              _getState$JWT = _getState$JWT === undefined ? {} : _getState$JWT;
              _getState$JWT$token = _getState$JWT.token, token = _getState$JWT$token === undefined ? '' : _getState$JWT$token;
              options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

              if (token) options.headers.Authorization = 'Bearer ' + token;

              _context.prev = 9;
              _context.next = 12;
              return fetch(APIEndpoint + 'v3/terms/loa/status', options);

            case 12:
              response = _context.sent;
              _context.next = 15;
              return response.json();

            case 15:
              status = _context.sent;

              dispatch({
                type: LOA_STATUS_FETCHED,
                term: status.type + 'Status',
                status: status.accepted
              });
              return _context.abrupt('return', status);

            case 20:
              _context.prev = 20;
              _context.t0 = _context['catch'](9);

              dispatch({
                type: LOA_STATUS_FAILED,
                message: 'request failed'
              });
              return _context.abrupt('return', Promise.reject('request failed'));

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[9, 20]]);
    }));

    function asyncFetchLOAStatus(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return asyncFetchLOAStatus;
  }();
}

function fetchLOAContent() {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, _state$userPrefs$loca, lang, options, response, html;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();

              if (!((0, _has3.default)(state, 'terms.loa.content.html') && state.terms.loa.content.html)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', Promise.resolve((0, _get3.default)(state, 'terms.loa.content.html')));

            case 3:
              _state$userPrefs$loca = state.userPrefs.localeData.lang, lang = _state$userPrefs$loca === undefined ? 'en-us' : _state$userPrefs$loca;
              options = { method: 'GET' };

              dispatch({
                type: LOA_CONTENT_FETCHING
              });
              _context2.prev = 6;
              _context2.next = 9;
              return fetch(APIEndpoint + 'v3/terms/loa?lang=' + lang, options);

            case 9:
              response = _context2.sent;
              _context2.next = 12;
              return response.text();

            case 12:
              html = _context2.sent;

              dispatch({
                type: LOA_CONTENT_FETCHED,
                html: html
              });
              _context2.next = 20;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2['catch'](6);

              dispatch({
                type: LOA_CONTENT_FAILED,
                message: _context2.t0.message
              });
              return _context2.abrupt('return', Promise.reject('request failed'));

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[6, 16]]);
    }));

    function asyncFetchLOAContent(_x3, _x4) {
      return _ref2.apply(this, arguments);
    }

    return asyncFetchLOAContent;
  }();
}

function fetchTermsStatus() {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var _getState2, _getState2$JWT, _getState2$JWT$token, token, options, termsStatusReponse, termsJSON, pass;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _getState2 = getState(), _getState2$JWT = _getState2.JWT;
              _getState2$JWT = _getState2$JWT === undefined ? {} : _getState2$JWT;
              _getState2$JWT$token = _getState2$JWT.token, token = _getState2$JWT$token === undefined ? '' : _getState2$JWT$token;

              dispatch({ type: TERMS_STATUS_FETCHING });

              options = { method: 'GET', headers: { 'Content-Type': 'application/json' } };

              if (token) options.headers.Authorization = 'Bearer ' + token;
              // Get term status, update their status in the store. If either
              // has not abeen accepted, return false, else return true

              _context3.prev = 6;
              _context3.next = 9;
              return fetch(APIEndpoint + 'v3/terms/appcenter/status', options);

            case 9:
              termsStatusReponse = _context3.sent;
              _context3.next = 12;
              return termsStatusReponse.json();

            case 12:
              termsJSON = _context3.sent;
              pass = true;

              if (!termsJSON.accepted) {
                pass = termsJSON.accepted;
              }
              dispatch({
                type: UPDATE_PREVIOUSLY_ACCEPTED_STATUS,
                term: termsJSON.type + 'Status',
                status: termsJSON.accepted
              });
              dispatch({ type: TERMS_STATUS_FETCHED });
              return _context3.abrupt('return', pass);

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3['catch'](6);
              throw _context3.t0;

            case 23:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[6, 20]]);
    }));

    function asyncFetchTermsStatus(_x5, _x6) {
      return _ref3.apply(this, arguments);
    }

    return asyncFetchTermsStatus;
  }();
}

function fetchTermsContent() {
  return function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var _getState3, appcenterTerms, options, response, data;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _getState3 = getState(), appcenterTerms = _getState3.terms.appcenterTerms;

              if (!appcenterTerms) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt('return');

            case 3:
              dispatch({ type: TERMS_FETCHING });

              options = {
                method: 'GET',
                headers: {}
              };
              _context4.next = 7;
              return fetch(APIEndpoint + 'v3/terms/', options);

            case 7:
              response = _context4.sent;
              _context4.next = 10;
              return response.json();

            case 10:
              data = _context4.sent;


              dispatch({
                type: TERMS_FETCHED,
                terms: data
              });

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function asyncFetchTermsContent(_x7, _x8) {
      return _ref4.apply(this, arguments);
    }

    return asyncFetchTermsContent;
  }();
}

function fetchSharedInfoContent(listingId, v1ListingId) {
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var _getState4, _getState4$userPrefs$, lang, ID, options, response, json, data;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _getState4 = getState(), _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang, lang = _getState4$userPrefs$ === undefined ? 'en-us' : _getState4$userPrefs$;


              dispatch({ type: SHARED_INFO_FETCHING });
              ID = void 0;

              if ((0, _has3.default)(getState(), 'listing[' + listingId + '].data.core')) {
                ID = listingId;
              } else {
                ID = v1ListingId;
              }
              options = {
                method: 'GET',
                headers: {}
              };
              _context5.prev = 5;
              _context5.next = 8;
              return fetch(APIEndpoint + 'v3/listings/' + ID + '/scopes?lang=' + lang, options);

            case 8:
              response = _context5.sent;
              _context5.next = 11;
              return response.json();

            case 11:
              json = _context5.sent;

              // TODO: what is this?
              data = json.map(function (i) {
                return i.description;
              });
              return _context5.abrupt('return', dispatch({
                type: SHARED_INFO_FETCHED,
                data: data
              }));

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5['catch'](5);
              return _context5.abrupt('return', Promise.reject(_context5.t0));

            case 19:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[5, 16]]);
    }));

    function asyncFetchSharedInfoContent(_x9, _x10) {
      return _ref5.apply(this, arguments);
    }

    return asyncFetchSharedInfoContent;
  }();
}

function updateTerms(userId) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'appcenter';

  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      var _getState5, _getState5$JWT, _getState5$JWT$token, token, options;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _getState5 = getState(), _getState5$JWT = _getState5.JWT;
              _getState5$JWT = _getState5$JWT === undefined ? {} : _getState5$JWT;
              _getState5$JWT$token = _getState5$JWT.token, token = _getState5$JWT$token === undefined ? '' : _getState5$JWT$token;

              dispatch({ type: TERMS_UPDATING });

              options = { method: 'PUT', headers: { 'Content-Type': 'application/json' } };

              if (token) options.headers.Authorization = 'Bearer ' + token;

              _context6.prev = 6;
              _context6.next = 9;
              return fetch(APIEndpoint + 'v3/terms/' + type + '/status', options);

            case 9:
              return _context6.abrupt('return', _context6.sent);

            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6['catch'](6);
              return _context6.abrupt('return', Promise.reject(_context6.t0));

            case 15:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this, [[6, 12]]);
    }));

    function asyncUpdateTerms(_x12, _x13) {
      return _ref6.apply(this, arguments);
    }

    return asyncUpdateTerms;
  }();
}

function toggleTaCModal(tAndCLinkClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_TAC_MODAL,
      tAndCLinkClicked: tAndCLinkClicked
    });
  };
}

function launchTaCModal(_ref7) {
  var tAndCLinkClicked = _ref7.tAndCLinkClicked,
      _ref7$flow = _ref7.flow,
      flow = _ref7$flow === undefined ? '' : _ref7$flow,
      listingId = _ref7.listingId,
      v1ListingId = _ref7.v1ListingId,
      _ref7$needAnAccountCl = _ref7.needAnAccountClicked,
      needAnAccountClicked = _ref7$needAnAccountCl === undefined ? { needAnAccountClicked: false } : _ref7$needAnAccountCl;

  return function (dispatch, getState) {
    var _getState6 = getState(),
        _getState6$terms = _getState6.terms,
        appcenterTerms = _getState6$terms.appcenterTerms,
        appcenterStatus = _getState6$terms.appcenterStatus;

    if (needAnAccountClicked) {
      dispatch(listingActions.toggleNeedAnAccountClicked(true));
    }

    if (tAndCLinkClicked && !appcenterTerms) {
      dispatch(toggleTaCModal(tAndCLinkClicked));
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
      dispatch(fetchLOAContent);
    } else {
      var ACTermsOK = appcenterStatus.previouslyAccepted || appcenterStatus.currentlyAccepted;
      if (flow === 'WEBFLOW' && ACTermsOK) {
        dispatch(listingActions.connectListing(listingId, v1ListingId));
        return;
      }
      dispatch(toggleTaCModal());
      dispatch(fetchTermsContent());
      dispatch(fetchSharedInfoContent(listingId, v1ListingId));
    }
  };
}

function updateCurrentlyAccepted(field, value) {
  return function (dispatch) {
    return dispatch({
      type: UPDATE_CURRENTLY_ACCEPTED_STATUS,
      field: field,
      value: value
    });
  };
}

var initialState = exports.initialState = {
  isTaCModalOpen: false,
  tAndCLinkClicked: false,
  appcenterStatus: { previouslyAccepted: false, currentlyAccepted: false },
  loa: {
    status: { previouslyAccepted: false, currentlyAccepted: false },
    content: { html: '' }
  },
  ereceiptStatus: { previouslyAccepted: false, currentlyAccepted: false },
  sharedInfoStatus: { currentlyAccepted: false },
  sharedInfo: [],
  content: [{
    type: 'appcenter',
    content: ''
  }]
};

// this reducer handles everything off of rootState.terms
function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case TOGGLE_TAC_MODAL:
      return (0, _merge5.default)({}, state, {
        isTaCModalOpen: !state.isTaCModalOpen,
        tAndCLinkClicked: action.tAndCLinkClicked
      });
    case UPDATE_PREVIOUSLY_ACCEPTED_STATUS:
      return (0, _merge5.default)({}, state, _defineProperty({}, action.term, {
        previouslyAccepted: action.status
      }));
    case UPDATE_CURRENTLY_ACCEPTED_STATUS:
      // loa has a different (newer, better) schema than appcenter and ereceipt
      if (action.field === 'loaStatus') {
        return (0, _merge5.default)({}, state, {
          loa: {
            status: {
              currentlyAccepted: action.value
            }
          }
        });
      }
      return (0, _merge5.default)({}, state, _defineProperty({}, action.field, {
        currentlyAccepted: action.value
      }));
    case TERMS_FETCHED:
      return _extends({}, state, {
        content: action.terms
      });
    case SHARED_INFO_FETCHED:
      return _extends({}, state, {
        sharedInfo: action.data
      });
    case LOA_STATUS_FETCHING:
      return _extends({}, state, {
        loa: _extends({}, state.loa, {
          status: {
            readyState: 'FETCHING'
          }
        })
      });
    case LOA_STATUS_FETCHED:
      return _extends({}, state, {
        loa: _extends({}, state.loa, {
          status: {
            readyState: 'FETCHED',
            previouslyAccepted: action.status,
            currentlyAccepted: action.status
          }
        })
      });
    case LOA_STATUS_FAILED:
      return _extends({}, state, {
        loa: _extends({}, state.loa, {
          status: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });
    case LOA_CONTENT_FETCHING:
      return _extends({}, state, {
        loa: _extends({}, state.loa, {
          content: {
            readyState: 'FETCHING'
          }
        })
      });
    case LOA_CONTENT_FETCHED:
      return _extends({}, state, {
        loa: _extends({}, state.loa, {
          content: {
            readyState: 'FETCHED',
            html: action.html
          }
        })
      });
    case LOA_CONTENT_FAILED:
      return _extends({}, state, {
        loa: _extends({}, state.loa, {
          content: {
            readyState: 'FAILED',
            message: action.message
          }
        })
      });
    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/terms/termsModule.js
// module id = 60
// module chunks = 0